import { z } from "zod";

import { isValidCompanyName, isValidName } from "../../handlers/validationFunctions";
import { emailField, phoneField, requiredString, tzLocationField } from "./fields";

export const referenceSchema = z.object({
	name: requiredString("Name is required").refine(isValidName, "Please enter a valid name"),
	designation: requiredString("Designation is required"),
	workPlace: requiredString("Workplace is required").refine(isValidCompanyName, "Please enter a valid company name"),
	address: tzLocationField(),
	country: requiredString("Country is required"),
	phoneNumber: phoneField(),
	email: emailField(),
});

export type ReferenceFormData = z.infer<typeof referenceSchema>;
